import * as React from "react";
import { injectIntl, InjectedIntlProps } from "react-intl";
import messages from "translations/messages";

const Loading = (props: InjectedIntlProps) => <div>{
  props.intl.formatMessage(messages["loader.pleaseWait"])
}</div>;

export default injectIntl(Loading);